import Esearcher from './Esearcher/index.js';

$(function () {
    var isInIframe = (window.location != window.parent.location) ? true : false;
    if (isInIframe) {
        return;
    }
    if (Cookies.get('__messages') !== undefined) {
        var e = Cookies.getJSON('__messages');
        Cookies.remove('__messages');
        var notifier = Esearcher.Ui.Notifier.getInstance();
        $.each(e, function (part, data) {
            $.each(data, function (a, text) {
                notifier.notify(text.replace(/&nbsp;/g, ' '), part);
            });
        });
    }
    var polling = new Esearcher.Polling(
        'reminderService-getCurrentReminders',
        60000,
        function (data) {
            for (var index = 0; index < data.length; ++index) {
                if (!($('#reminder_' + data[index].id).length)) {
                    new PNotify({
                        id: '#reminder_'+data[index].id,
                        title: data[index].title,
                        text: data[index].html,
                        hide: false,
                        buttons: {
                            closer: false,
                            sticker: false
                        }
                    });
                }

            }
            bindDeactiveReminderEvent();
            bindDelay60ReminderEvent();
            bindSelectDelayEvent();
        },
        true
    );
    var connect = Esearcher.Connect.getInstance();
    connect.poll(polling);

    function bindDeactiveReminderEvent() {
        $(document).off('click', '[name=deactivate]');
        $(document).on('click', '[name=deactivate]', function (e) {
            var id = $(e.target).attr('data-id');
            $.ajax({
                url: '/reminder/disable/'+id,
                method: 'POST',
            }).done(function() {
                for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
                connect.runPolling('reminderService-getCurrentReminders');
            });
        });
    }

    function bindDelay60ReminderEvent() {
        $(document).off('click', '[name=delay60]');
        $(document).on('click', '[name=delay60]', function (e) {
           var id = $(e.target).attr('data-id');
           $.ajax({
               url: '/reminder/delay/60/'+id,
               method: 'POST'
           }).done(function() {
               for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
               connect.runPolling('reminderService-getCurrentReminders');
           });
        });
    }

    function bindSelectDelayEvent() {
        $(document).off('click', '[name=delay]');
        $(document).on('click', '[name=delay]', function (e) {
            var target = e;
            var delay = $(e.target).attr('data-id');
            var id = $(e.target).attr('id');
            $.ajax({
               url: '/reminder/delay/'+delay+'/'+id,
               method: 'POST'
            }).done(function() {
                for (var i = 0; i < PNotify.notices.length; i++) {
                    if (PNotify.notices[i].options.id == "#reminder_"+id) {
                        PNotify.notices[i].remove();
                    }
                }
                localStorage.removeItem("last-po-request-at");
				localStorage.removeItem("po-data-loaded-at");
            });
        });
    }
});